import React, { Suspense } from 'react';

// project imports
import Loader from './Loader';

// ==============================|| CHUNK ERROR BOUNDARY ||============================== //

class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error) {
    const errorMsg = error?.message || '';
    const isChunkError =
      errorMsg.includes('Failed to fetch dynamically imported module') ||
      errorMsg.includes('Importing a module script failed') ||
      errorMsg.includes('error loading dynamically imported module') ||
      error?.name === 'ChunkLoadError';

    if (isChunkError) {
      const reloadKey = 'chunk_reload_' + window.location.pathname;
      if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, 'true');
        window.location.reload();
      }
    }
  }

  render() {
    if (this.state.hasError) {
      const errorMsg = this.state.error?.message || '';
      const isChunkError =
        errorMsg.includes('Failed to fetch dynamically imported module') ||
        errorMsg.includes('Importing a module script failed') ||
        errorMsg.includes('error loading dynamically imported module') ||
        this.state.error?.name === 'ChunkLoadError';

      if (isChunkError) {
        return (
          <div style={{ padding: '40px 20px', textAlign: 'center' }}>
            <h3 style={{ fontSize: '1.25rem', marginBottom: '8px', color: '#1f2937' }}>
              Application Update Available
            </h3>
            <p style={{ color: '#4b5563', marginBottom: '16px' }}>
              A newer version of this page is available. Please reload the page.
            </p>
            <button
              onClick={() => {
                sessionStorage.removeItem('chunk_reload_' + window.location.pathname);
                window.location.reload();
              }}
              style={{
                padding: '8px 20px',
                backgroundColor: '#1890ff',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 500
              }}
            >
              Reload Page
            </button>
          </div>
        );
      }

      return (
        <div style={{ padding: '20px', textAlign: 'center', color: '#dc2626' }}>
          <p style={{ fontWeight: 600 }}>Failed to load component. Please try reloading the page.</p>
          {this.state.error?.message && (
            <p style={{ fontSize: '0.8rem', color: '#6b7280', marginTop: '4px' }}>
              {this.state.error.message}
            </p>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component) => (props) => {
  return (
    <ChunkErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Component {...props} />
      </Suspense>
    </ChunkErrorBoundary>
  );
};

export default Loadable;

